let head = 'http://localhost:3011/'
head = 'http://42.81.134.213:3011/'
head = 'https://api.aiotcloud.nxp.com.cn/'

// eslint-disable-next-line import/no-anonymous-default-export
export default head


